import { component } from 'picoapp';
import { clear, scrollLock } from 'utils/node';
import Drawer from 'utils/drawer';

export default component((node, ctx) => {
  const { sectionId } = node.dataset;

  const toggles = document.querySelectorAll('[data-cart]');
  const form = node.querySelector('[data-form]');

  const selectors = {
    total: '[data-total]',
    totals: '[data-total-prices]',
    items: '[data-items]',
    shipping: '[data-shipping-container]',
    edits: '[data-cart-edits]',
  };

  const cartTotal = node.querySelector(selectors.total);
  const cartTotalPrices = node.querySelector(selectors.totals);
  const listContainer = node.querySelector(selectors.items);
  const shippingContainer = node.querySelector(selectors.shipping);
  const editsContainer = document.querySelector(selectors.edits);

  const drawer = Drawer(form, node);

  drawer.on('opened', () => scrollLock());
  drawer.on('close', () => scrollLock(false));

  document.addEventListener('click', (event) => {
    if (event.target && event.target.closest(`a[href="${window.theme.routes.cart}"]`)) {
      event.preventDefault();
      drawer.open();
    }
  });

  form.addEventListener('submit', (e) => {
    const termsAccept = ctx.getState().accept;

    if (!termsAccept) {
      e.preventDefault();
      ctx.emit('terms:accept', { accept: false });
    }
  });

  toggles.forEach((item) => {
    item.addEventListener('click', (event) => {
      event.preventDefault();
      drawer.toggle();
    });
  });

  ctx.on('cart:updating', () => {
    node.classList.add('updating');
  });

  node.addEventListener('click', async (event) => {
    if (event.target.hasAttribute('data-change')) {
      event.preventDefault();

      event.target.textContent = window.theme.strings.removing;
      ctx.emit('cart:updating');

      const url = new URL(event.target.href);
      url.pathname = `${url.pathname}.js`;

      const response = await fetch(url.href);
      const data = await response.json();

      ctx.emit('cart:updated', ({ cart: data }));
    }
  });

  const getCartHTML = async () => {
    const response = await fetch(`/?sections=${sectionId}`);
    const html = await response.json();

    const placeholder = document.createElement('div');
    placeholder.innerHTML = html[sectionId];

    const shipping = placeholder.querySelector(selectors.shipping).innerHTML;
    const items = placeholder.querySelector(selectors.items).innerHTML;
    const edits = placeholder.querySelector(selectors.edits).innerHTML;
    const total = placeholder.querySelector(selectors.total).innerHTML;
    const totals = placeholder.querySelector(selectors.totals).innerHTML;

    return {
      items,
      shipping,
      edits,
      total,
      totals,
    };
  };

  const updateCount = ({ item_count: itemCount }) => {
    const counts = document.querySelectorAll('[data-cart-count]');

    counts.forEach((count) => {
      count.innerHTML = itemCount;
    });
  };

  // Handle cart redirect
  const cartRedirect = () => {
    const params = new URLSearchParams(window.location.search);
    const cartDrawer = params.get('cartDrawer');

    if (cartDrawer && cartDrawer === 'open') {
      drawer.open();
    }
  };

  cartRedirect();

  ctx.on('cart:updated', async ({ cart }) => {
    window.theme.cart = cart;

    const {
      items,
      shipping,
      edits,
      total,
      totals,
    } = await getCartHTML();

    clear(cartTotalPrices);
    clear(cartTotal);
    clear(listContainer);
    clear(shippingContainer);
    clear(editsContainer);

    updateCount(cart);

    cartTotalPrices.insertAdjacentHTML('beforeend', totals);
    cartTotal.insertAdjacentHTML('beforeend', total);
    listContainer.insertAdjacentHTML('beforeend', items);
    shippingContainer.insertAdjacentHTML('beforeend', shipping);
    editsContainer.insertAdjacentHTML('beforeend', edits);

    drawer.open();
    document.dispatchEvent(new CustomEvent('app:mount'));

    node.classList.remove('updating');
  });
});
